module.exports = __webpack_public_path__ + "img/654-db8008.png";